import get from '@/ajax/shop/client/get';
import login from '@/ajax/shop/client/login';
import logout from '@/ajax/shop/client/logout';

export default {
  get,
  login,
  logout
};
